import upperFirst from 'lodash.upperfirst';
import { ID } from '../constants';

const isFilterEntitysId = (entityName, itemEntityUpdated) => {
  const id = upperFirst(ID);
  return [
    `${itemEntityUpdated}${id}`,
    `${itemEntityUpdated}s${id}`,
    `${itemEntityUpdated}${id}s`,
    `${itemEntityUpdated}s${id}s`
  ].includes(entityName);
};

export default isFilterEntitysId;
